import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Dropdown, Icon, Layout, Menu} from 'antd';

const Header = Layout.Header;

class AppHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: props.userData
        };
        this.handleMenuClick = this.handleMenuClick.bind(this);
    }

    handleMenuClick({key}) {
        if (key === "logout") {
            this.props.onLogout();
        }
    }

    render() {
        const menuItems = [];
        if (this.state && this.state.userData) {
            menuItems.push(
                <Menu.Item key="/profile" className="profile-menu">
                    <ProfileDropdownMenu userData={this.state.userData} handleMenuClick={this.handleMenuClick}/>
                </Menu.Item>
            );
        }

        return (
            <Header className="app-header">
                <div className="container">
                    <div className="app-title">
                        <Link to="/">Hodoor</Link>
                    </div>
                    <Menu className="app-menu" mode="horizontal" style={{lineHeight: '64px'}}>
                        {menuItems}
                    </Menu>
                </div>
            </Header>
        );
    }
}

function ProfileDropdownMenu(props) {
    const dropdownMenu = (
        <Menu onClick={props.handleMenuClick} className="profile-dropdown-menu">
            <Menu.Item key="user-info" className="dropdown-item" disabled>
                <div className="user-full-name-info">{props.userData.name}</div>
                <div className="username-info">{props.userData.id}</div>
            </Menu.Item>
            <Menu.Divider/>
            <Menu.Item key="profile" className="dropdown-item">
                <Link to={`/users/profile`}>{'Perfil'}</Link>
            </Menu.Item>
            <Menu.Divider/>
            <Menu.Item key="logout" className="dropdown-item">{'Logout'}</Menu.Item>
        </Menu>
    );

    return (
        <Dropdown overlay={dropdownMenu} trigger={['click']}
                  getPopupContainer={() => document.getElementsByClassName('profile-menu')[0]}>
            <a className="ant-dropdown-link">
                <Icon type="user" className="nav-icon" style={{marginRight: 0}}/> <Icon type="down"/>
            </a>
        </Dropdown>
    );
}

export default withRouter(AppHeader);


// WEBPACK FOOTER //
// ./src/app/components/AppHeader.js